import { api } from './api'

function assertSuccess(body) {
  if (!body?.success) {
    const err = new Error(body?.message || 'Request failed')
    err.code = body?.error?.code
    throw err
  }
  return body.data
}

function apiError(err) {
  const msg = err.response?.data?.message || err.message || 'Request failed'
  const next = new Error(msg)
  next.code = err.response?.data?.error?.code
  next.status = err.response?.status
  return next
}

/**
 * super_admin — set optional per-store App Store / Play Store listing URLs (HTTPS, Apple / Google hosts only).
 * @param {string|number} storeId
 * @param {{ iosAppStoreUrl?: string | null, androidPlayStoreUrl?: string | null }} body
 */
export async function patchStoreMobileAppLinks(storeId, body) {
  try {
    const { data } = await api.patch(`/admin/stores/${encodeURIComponent(String(storeId))}/mobile-app-links`, body)
    return assertSuccess(data)
  } catch (e) {
    throw apiError(e)
  }
}
